import React, { useEffect, useCallback } from 'react'

// useNavigationWarning 훅 정의
const useNavigationWarning = (shouldWarn, message) => {
	const handleBeforeUnload = useCallback(
		(event) => {
			if (shouldWarn) {
				event.preventDefault()
				event.returnValue = message
				return message
			}
		},
		[shouldWarn, message],
	)

	useEffect(() => {
		if (shouldWarn) {
			window.addEventListener('beforeunload', handleBeforeUnload)
		}

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload)
		}
	}, [shouldWarn, handleBeforeUnload])
}

export const AdvancedNavigationGuard = ({
	children,
	warningMessage = '현재 페이지를 떠나시겠습니까?',
}) => {
	useNavigationWarning(true, warningMessage)

	return <>{children}</>
}
